import { useNavigate } from 'react-router-dom';
import classes from './factsHome.module.scss';
import changeDrugStatus from 'assets/icons/changeDrugStatusIcon.svg';
import activeDrugStrategy from 'assets/icons/activeDrugStrategy.svg';
import { screenDataInterface } from 'Interfaces/navigationScreenDataInterface';
import { observer } from 'mobx-react';
import { useStore } from 'hooks/useStore';

const FactsHomeScreen = () => {
  const navigate = useNavigate();
  const { FeatureFlagStore } = useStore();

  const flagEnabled = (key: string) => !FeatureFlagStore.isLoaded || FeatureFlagStore.isEnabled(key);

  const screenData: screenDataInterface = [
    {
      location: '/facts/drug_portfolio_management',
      img: changeDrugStatus,
      label: 'Drug Portfolio Management',
      disabled: !flagEnabled('facts.drug_portfolio'),
    },
    {
      location: '/facts/active_drug_strategy',
      img: activeDrugStrategy,
      label: 'Active Drug Strategy Adjustments',
      disabled: !flagEnabled('facts.active_drug_strategy'),
    },
  ];

  return (
    <div className={classes.factsScreen}>
      {screenData.filter(data => !data.disabled).map((data, index) => (
        <div onClick={() => navigate(data.location)} key={index}>
          <div className={classes.btnSection}>
            <div>
              <div className={classes.imgBackground}></div>
              <img src={data.img} alt={`${data.label} icon`} />
            </div>
            <p>{data.label}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default observer(FactsHomeScreen);
